import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	ViewEncapsulation,
} from '@angular/core';
import { FormGroup, UntypedFormBuilder } from '@angular/forms';

@Component({
	selector: 'ms-listbox',
	templateUrl: './ms-listbox.component.html',
	styleUrls: ['./ms-listbox.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class MsListboxComponent implements OnInit, OnDestroy {
	@Input({ alias: 'class', required: false })
	class: string | string[];

	@Input({ alias: 'listClass', required: false })
	listClass: string | string[];

	@Output('onSelected')
	_onSelected = new EventEmitter<any>();

	@Output('onMouseOver')
	_onMouseOver = new EventEmitter<any>();

	@Input({ alias: 'items', required: true })
	items: any[];

	_selected: any;
	formGroup: FormGroup;

	/**
	 * Constructor
	 */
	constructor(private _formBuilder: UntypedFormBuilder) {}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.formGroup = this._formBuilder.group({
			search: ['', []],
		});
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------
	onSelected(item: any): void {
		this._selected = item;
		this._onSelected.emit(item);
		this.reset();
	}

	onMouseOver(item: any): void {
		this._onMouseOver.emit(item);
	}

	public reset(): void {
		this._selected = null;
		this.formGroup.reset();
	}
	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
}
